import React from "react";
import cx from "clsx";
import { Link } from "react-router-dom";
import { useCurrentAccountQuery } from "../../../../../api/queries/useAccountQuery";
import { PERMISSIONS, PLAN_CODES } from "../../../../../consts/api";
import { usePermission } from "../../../../../hooks/usePermission";
import { SETTINGS_ROUTES } from "../../../../../consts/routes";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";

/**
 * @param {{
 *  active: "simpleQ" | "multiQ" | "providerQ" | "consents" | "membershipAgreement"
 * }}
 */
export const PaperworkMenu = ({ active }) => {
  const { tCommon: t } = useAppTranslation.Common();

  const { data: account } = useCurrentAccountQuery();

  const isTouchMd = account?.preferences?.isTouchMd || false;
  const isBookingPlan = account?.subscription?.planCode === PLAN_CODES.booking;

  const manageQuestionnaires = usePermission(
    PERMISSIONS.settings.manageQuestionnaires,
  );

  const manageConsents = usePermission(PERMISSIONS.settings.manageConsents);

  return (
    <div className="setting-setion m-b-10">
      <div className="membership-title">
        <div className="newTabsOuter">
          {isTouchMd && isBookingPlan
            ? ""
            : manageQuestionnaires.permitted && (
                <Link
                  to={SETTINGS_ROUTES.cosmeticQuestionnaires()}
                  className={cx("newTabs", {
                    "disabled-tab": active !== "simpleQ",
                  })}
                >
                  {t("label.simpleQuestionnaires")}
                </Link>
              )}

          {manageQuestionnaires.permitted && (
            <Link
              to={SETTINGS_ROUTES.healthTimelineQuestionnaires()}
              className={cx("newTabs", {
                "disabled-tab": active !== "multiQ",
              })}
            >
              {isTouchMd && isBookingPlan
                ? "Questionnaires"
                : t("label.multiQuestionnaires")}
            </Link>
          )}

          {manageQuestionnaires.permitted && (
            <Link
              to={SETTINGS_ROUTES.providerQuestionnaires()}
              className={cx("newTabs", {
                "disabled-tab": active !== "providerQ",
              })}
            >
              Provider Questionnaires
            </Link>
          )}

          {manageConsents.permitted && (
            <Link
              to={SETTINGS_ROUTES.consents()}
              className={cx("newTabs", {
                "disabled-tab": active !== "consents",
              })}
            >
              Consents
            </Link>
          )}

          {isTouchMd && isBookingPlan ? (
            ""
          ) : (
            <Link
              to={SETTINGS_ROUTES.membershipAgreements()}
              className={cx("newTabs", {
                "disabled-tab": active !== "membershipAgreement",
              })}
            >
              Membership Agreement
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
